// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.transition-container {
  overflow: hidden;
  transition: max-height 0.5s ease-in-out, opacity 0.5s ease-in-out;
}

.transition-container.collapsed {
  max-height: 0;
  opacity: 0;
}

.transition-container.expanded {
  max-height: 1000px;
  opacity: 1;
}

.new-certificate-btn {
  color: #3256ed;
  border-radius: 5px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./../portfolio/src/components/CandidateCertificationDetailsSection/CandidateCertificationDetailsSection.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,iEAAA;AACF;;AAEA;EACE,aAAA;EACA,UAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;AACF;;AAEA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;AACF","sourcesContent":[".transition-container {\n  overflow: hidden;\n  transition: max-height 0.5s ease-in-out, opacity 0.5s ease-in-out;\n}\n\n.transition-container.collapsed {\n  max-height: 0;\n  opacity: 0;\n}\n\n.transition-container.expanded {\n  max-height: 1000px;\n  opacity: 1;\n}\n\n.new-certificate-btn {\n  color: #3256ed;\n  border-radius: 5px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
